import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'

export type DatePickerPropsDayjs = Omit<DatePickerProps, 'sx'>

export default DatePicker
